import { useState, useEffect } from "react";
import CommonButton from "../../common/component/commonButton";
import CommonInput from "../../common/component/commonInput";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import useValidation from "../../common/utils/validationRules";
import { useSelector } from "react-redux";
import CommonLoader from "../../common/component/commonLoader";
import { useLoader } from "../../common/component/LoaderProvider";
import { useToast } from "../../common/component/Toast";
import { useTranslation } from "react-i18next";
import CommonDropdown from "../../common/component/commonDropdown";
import CommonPhoneInput from "../../common/component/commonPhoneInput";
import { getRegion ,getAslCheck} from "../../service/action/actioncreator/HospitalAction/Hospital";
import { updateRetail } from "../../service/action/actioncreator/RetailAction/Retail";
import { extractPhoneNumber } from "../../common/utils/commonFunction";

const RetailView = ({
  pharmacyViewData,
  viewRoleId,
  aslDropdown,
  retailListData,
  rowDataView,
  viewDetails="",
  handlePreviousList=()=>{},
}) => {
  const dispatch = useDispatch();
  const regionDropdown = useSelector(
    (state) => state.hospitalReducer.regionListResponse
  );
  const aslRegionDropdown = useSelector(
    (state) => state.hospitalReducer.regionASLListResponse
  );
  const loading = useSelector(
    (state) => state.retailReducer.retailUpdateLoading
  );
  const { t } = useTranslation("translation");
  const showToast = useToast();
  const { loadingStepper, showLoader, hideLoader } = useLoader();

  const formattedValue = regionDropdown?.result?.map((option) => ({
    label: `${option?.regionName}`,
    value: option?.regionCode,
  }));

  const aslOptions = aslRegionDropdown?.result?.map((option) => ({
    label: `${option?.regionName}${","} ${option?.municipality}${","} ${
      option?.companyName
    }`,
    value: option?.id,
  }));

  const [isRegionChanged, setIsRegionChanged] = useState(false);
  const disptach = useDispatch();
  const { validateField } = useValidation();
  const [countryDialCode, setCountryDialCode] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [success,setSuccess]=useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    control,
    watch,
    trigger,
    reset,
  } = useForm({ mode: "onChange" });

  watch("asl");
  watch("regione");
  watch("indirizzo");
  watch("ministerialId");
  watch("denominazione");
  watch("provincia");
  watch("city");
  watch("PhoneNumber");

  const mofificationFn = () => {
    setIsEditing(true);
    // setValue(
    //   "asl",
    //   aslOptions?.find((obj) => obj.value == pharmacyViewData?.asl)?.value
    // );
    setValue(
      "asl",
      `${pharmacyViewData?.companyName}, ${pharmacyViewData?.region}, ${pharmacyViewData?.municipality}`
    );
    setValue("vat", pharmacyViewData?.vat);
    setValue("ministerialId", pharmacyViewData?.ministerialId);
    setValue(
      "regione",
      formattedValue?.find((obj) => obj.label === pharmacyViewData?.region)
        ?.label
    );
    setValue("indirizzo", pharmacyViewData?.address);
    setValue("denominazione", pharmacyViewData?.name);
    setValue("provincia", pharmacyViewData?.province);
    setValue("city", pharmacyViewData?.city);
    setValue("PhoneNumber", pharmacyViewData?.phoneNumber);
  };

  const handleCountryChange = (data) => {
    setCountryDialCode(data.dialCode);
  };

  const handleRemain = () => {
    const selectedRegionValue = watch("regione");
    const selectedRegion = formattedValue?.find(
      (obj) => obj.value === selectedRegionValue
    );
    const regionLabel = selectedRegion?.label || "";
    const payload = {
      ...pharmacyViewData,
      isActive: true,
      name: getValues("denominazione"),
      region: regionLabel,
      asl: isRegionChanged ? getValues("asl") : pharmacyViewData?.asl,
      city: getValues("city")?.toString(),
      province: getValues("provincia"),
      address: getValues("indirizzo"),
      ministerialId: getValues("ministerialId"),
      vat: getValues("vat"),
      phoneNumber:`${extractPhoneNumber(countryDialCode,getValues("PhoneNumber"))}`
      //  countryDialCode
      //   ? `${countryDialCode} ${getValues("PhoneNumber")?.slice(
      //       countryDialCode?.length
      //     )}`
        // : getValues("PhoneNumber")?.slice(countryDialCode?.length),
      //  phoneNumber:`${extractPhoneNumber(countryDialCode,getValues("HospitalNumber"))}`
    };
    const headers = {
      AccessIdentifier: "validate",
    };
    if (Object.keys(errors).length == 0) {
      console.log("check900")
      disptach(
        updateRetail(
          pharmacyViewData?.id,
          payload,
          headers,
          showLoader,
          hideLoader,
          showToast,
          t,
          pharmacyViewData?.id,
          setIsEditing,
         
        )
      );
    }
  };
    const handleCheck=()=>{
        let payload={
          id:pharmacyViewData?.id,
          asl:isRegionChanged?getValues("asl"):pharmacyViewData?.asl,
          name:getValues("denominazione"),
          type:"Retail"
        }
        dispatch(getAslCheck(payload, showLoader,
          hideLoader,
          showToast,
          t,
          setSuccess,
          handleRemain))
      }

  const handleclose = () => {
    setIsEditing(false);
    reset();
  };
  useEffect(() => {
    setPhoneNumber(getValues("PhoneNumber") ?? "");
  }, [getValues("PhoneNumber")]);

  useEffect(() => {
    let year = "2024";
    let regionCode = "";
    let header={
      isAll:true
    }
    dispatch(getRegion(year, regionCode,header));
  }, []);

  useEffect(() => {
    const selectedRegion = regionDropdown?.result?.find(
      (region) => region.regionCode == getValues("regione")
    );
    if (selectedRegion) {
      setValue("asl","")
      let year = "2024";
      let regionCode = selectedRegion.regionCode;
      let header={
        isAll:true
      }
      dispatch(getRegion(year, regionCode,header));
    }
  }, [getValues("regione")]);

  useEffect(() => {
    if (watch("regione") !== pharmacyViewData?.region) {
      setIsRegionChanged(true);
    } else {
      setIsRegionChanged(false);
    }
  }, [watch("regione")]);

  const fetchDropdownOptions = () => {
    let year = "2024";
    let regionCode = "";
    setValue("asl", "");
    let header={
      isAll:true
    }
    dispatch(getRegion(year, regionCode,header));
  };
  return (
    <div className="p-2 bg-white shadow-md rounded-xl structure-view">
      <div className="row mt-2">
        <div className="col-md-4 mt-2">
          <h4 className="border-bottom-2 pb-2  titlevalues">
            {" "}
            Informazioni di base
          </h4>

          <div className="d-flex flex-row justify-content-between gap-3">
            <div className="col-lg-12 col-xl-12 col-md-12 mt-1">
              <strong className="mt-1">DENOMINAZIONE</strong>
              {isEditing ? (
                <CommonInput
                  name={"denominazione"}
                  register={register}
                  inputStyle={true}
                  errors={errors}
                  errorFlag={true}
                  validationFn={validateField}
                  control={control}
                  errorStyle={true}
                  className="mt-2"
                />
              ) : (
                <p>{pharmacyViewData?.name}</p>
              )}
            </div>
            <div className="col-lg-6 col-xl-6 col-md-12 mt-1">
              <strong className="mt-1">ID Ministeriale</strong>
              {isEditing ? (
                <CommonInput
                  name={"ministerialId"}
                  register={register}
                  inputStyle={true}
                  errors={errors}
                  errorFlag={true}
                  validationFn={validateField}
                  control={control}
                  errorStyle={true}
                  className="mt-2"
                />
              ) : (
                <p>{pharmacyViewData.ministerialId}</p>
              )}
            </div>

            <div className="col-lg-6 col-xl-6 col-md-12 mt-1">
              <strong className="mt-1">REGIONE</strong>
              {isEditing ? (
                <CommonDropdown
                  name={"regione"}
                  options={formattedValue}
                  control={control}
                  register={register}
                  validationFn={validateField}
                  // onFocus={fetchDropdownOptions}
                />
              ) : (
                <p>{pharmacyViewData.region}</p>
              )}
            </div>
            <div className="col-lg-12 col-xl-12 col-md-12 mt-1">
              <strong className="mt-1">ASL RIFERIMENTO</strong>
              {isEditing ? (
                <CommonDropdown
                  name={"asl"}
                  options={aslOptions}
                  control={control}
                  register={register}
                  validationFn={validateField}
                  disableArrowIcon={true}
                  disabled={!isRegionChanged}
                />
              ) : (
                <p>
                  {pharmacyViewData?.companyName}, {pharmacyViewData?.region},{" "}
                  {pharmacyViewData?.municipality}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-4 mt-2">
          <div className="d-flex flex-row justify-content-between gap-3">
            <div className="col-lg-12 col-xl-12 col-md-12 mt-1">
              <strong className="mt-1">INDIRIZZO</strong>
              {isEditing ? (
                <CommonInput
                  name={"indirizzo"}
                  register={register}
                  inputStyle={true}
                  errors={errors}
                  errorFlag={true}
                  validationFn={validateField}
                  control={control}
                  errorStyle={true}
                  className="mt-2"
                />
              ) : (
                <p>{pharmacyViewData?.address}</p>
              )}
            </div>

            <div className="col-lg-6 col-xl-6 col-md-12 mt-1">
              <strong className="mt-1">PROVINCIA</strong>
              {isEditing ? (
                <CommonInput
                  name={"provincia"}
                  register={register}
                  inputStyle={true}
                  errors={errors}
                  errorFlag={true}
                  validationFn={validateField}
                  control={control}
                  errorStyle={true}
                  className="mt-2"
                  maxLength={true}
                />
              ) : (
                <p>{pharmacyViewData.province}</p>
              )}
            </div>

            <div className="col-lg-6 col-xl-6 col-md-12 mt-1">
              <strong className="mt-1">COMUNE</strong>

              {isEditing ? (
                <CommonInput
                  name={"city"}
                  register={register}
                  inputStyle={true}
                  errors={errors}
                  errorFlag={true}
                  validationFn={validateField}
                  control={control}
                  errorStyle={true}
                  className="mt-2"
                />
              ) : (
                <p>{pharmacyViewData?.city}</p>
              )}
            </div>
            <div className="col-lg-6 col-xl-6 col-md-12 mt-1">
              <strong className="mt-1">P.IVA</strong>
              {isEditing ? (
                <CommonInput
                  placeholder={"P.IVA"}
                  name={"vat"}
                  register={register}
                  inputStyle={true}
                  errors={errors}
                  errorFlag={true}
                  validationFn={validateField}
                  control={control}
                  errorStyle={true}
                  className="mt-2"
                />
              ) : (
                <p>{pharmacyViewData.vat}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-4 mt-2">
          <div className="d-flex flex-row justify-content-between gap-3">
            <div className="col-lg-6 col-xl-6 col-md-6 mt-1">
              <strong className="mt-1">TELEFONO</strong>

              {isEditing ? (
                <CommonPhoneInput
                  name={"PhoneNumber"}
                  control={control}
                  errors={errors}
                  register={register}
                  validationFn={validateField}
                  requiredField={true}
                  errorStyle={true}
                  errorFlag={true}
                  onCountryChange={handleCountryChange}
                  isNextClicked={true}
                  changeCallback={()=>{}}
                />
              ) : (
                <p>{pharmacyViewData?.phoneNumber}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mt-4">
        {isEditing ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              gap: "2%",
            }}
          >
            <CommonButton
              label="Salva"
              onClick={() => handleCheck()}
              variant="success"
              inputStyle={true}
              className="btn btn-success mt-3 pl-4 pr-4  w-20 input-style-common text-white text-center"
              disabled={
                getValues("denominazione")?.length === 0 ||
                getValues("ministerialId")?.length === 0 ||
                getValues("asl")?.length ===0||
                getValues("regione")?.length ===0||
                getValues("indirizzo")?.length === 0 ||
                getValues("provincia")?.length === 0 ||
                getValues("city")?.length === 0 ||
                (!isNaN(getValues('PhoneNumber')) &&
                !( getValues("PhoneNumber")?.slice(countryDialCode?.length)?.length >= 10))||
                getValues("vat")?.length === 0
              }
            />
            <CommonButton
              label="Cancella"
              onClick={() => handleclose()}
              className="btn btn-cancel mt-3 input-style-common btn-cancel-style  pl-2 btn-padding primary-text-color"
              variant={"cancel"}
            />
          </div>
        ) : (
          <div className="d-flex justify-content-end align-items-center h-auto">
            <CommonButton
              className="btn btn-success mt-3 p-2  w-20 input-style-common text-white text-center"
              inputStyle={true}
              label={viewDetails==="editData" ?  "Modifica" : "Annulla"}
              variant={"success"}
              onClick={viewDetails==="editData" ?  mofificationFn : handlePreviousList }
              disabled={rowDataView?.isActive == true ? false : true}
            />
          </div>
        )}
      </div>
      {/* {errors.PhoneNumber ? (
        <div className="p-error">{errors.PhoneNumber.message}</div>
      ) : (
        ""
      )} */}
      {!loadingStepper && <CommonLoader loading={loading} />}
    </div>
  );
};
export default RetailView;
